import React from "react";

function DownArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35px"
      height="35px"
      fill="#61a4b8"
      stroke="#61a4b8"
      version="1.1"
      viewBox="0 0 64 64"
      xmlSpace="preserve"
    >
      <g>
        <g>
          <path d="M17.293 29.707a1 1 0 111.414-1.414L32 41.586l13.293-13.293a1 1 0 111.414 1.414l-14 14a1 1 0 01-1.414 0l-14-14z"></path>
          <path d="M32 64c17.673 0 32-14.327 32-32S49.673 0 32 0C14.327 0 0 14.327 0 32s14.327 32 32 32zm0-2C15.458 62 2 48.542 2 32S15.458 2 32 2s30 13.458 30 30-13.458 30-30 30z"></path>
        </g>
      </g>
    </svg>
  );
}

export default DownArrow;
